import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { thunks as DownloadThunks } from 'reducers/Downloads'
import { downloadZipperQueuryInterval, maxDownloadConcurrency } from 'config'
import { DownloadTaskType, DownloadTaskStatus } from 'constants/enums'
import first from 'lodash/first'

/**
 * This component is in charge of the download queue.
 * It does not render anything but it just utilize the connect method from react-redux such that it can grab states, dipatch actions and thunks easily.
 */
class DownloadManager extends React.Component {
  static propTypes = {
    downloads: PropTypes.arrayOf(PropTypes.object),
    dispatch: PropTypes.func,
    format: PropTypes.string
  }

  componentDidMount() {
    this.startRunLoop()
  }

  componentDidUpdate(prevProps) {
    const { downloads } = this.props
    const { downloads: preDownloads } = prevProps

    if (
      downloads.filter(this.isStatusLoading).length !==
      preDownloads.filter(this.isStatusLoading).length
    ) {
      this.checkZipperReadyForTasks()
    }
  }

  componentWillUnmount() {
    this.endRunLoop()
  }

  isStatusLoading = (download) => {
    return download && download.status === DownloadTaskStatus.loading
  }

  startRunLoop = () => {
    this.timer = setInterval(this.timerRunnable, downloadZipperQueuryInterval)
  }

  timerRunnable = () => {
    const { downloads } = this.props
    this.startNextTaskIfPossible()
    this.checkZipperReadyForTasks(downloads)
  }

  startNextTaskIfPossible = () => {
    const { downloads, dispatch, format } = this.props
    const loadingTasks = downloads.filter(
      (download) => download.status === DownloadTaskStatus.loading
    )
    if (loadingTasks.length < maxDownloadConcurrency) {
      const nextDownload = first(downloads.filter(this.canStartDownload))
      if (nextDownload) {
        if (nextDownload.type === DownloadTaskType.video) {
          dispatch(
            DownloadThunks.startVideoDownload(nextDownload, format)
          )
        } else {
          dispatch(DownloadThunks.startDownload(nextDownload))
        }
      }
    }
  }

  checkZipperReadyForTasks = () => {
    const { downloads, dispatch } = this.props
    const downloadsNeedToBeChecked = downloads.filter((download) => {
      return (
        (download.type === DownloadTaskType.release ||
          download.type === DownloadTaskType.playlist) &&
        download.status === DownloadTaskStatus.waiting &&
        typeof download.token === 'string' &&
        download.token.length > 0 &&
        !download.zipperReady
      )
    })

    downloadsNeedToBeChecked.forEach((download) => {
      dispatch(
        DownloadThunks.asyncQueryZipperReady(download, () => {
          this.startNextTaskIfPossible()
        })
      )
    })
  }

  endRunLoop = () => {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  canStartDownload = (download) => {
    if (
      download.type === DownloadTaskType.release ||
      download.type === DownloadTaskType.playlist
    ) {
      return (
        download.zipperReady && download.status === DownloadTaskStatus.waiting
      )
    } else if (
      download.type === DownloadTaskType.song ||
      download.type === DownloadTaskType.video
    ) {
      return (
        download.status === DownloadTaskStatus.waiting &&
        download.token.length &&
        download.url.length
      )
    } else {
      return false
    }
  }

  render() {
    return null
  }
}

const mapStateToProps = ({ downloads, profile }) => ({
  downloads: downloads.downloads,
  format: profile.profile.format
})

export default connect(mapStateToProps)(DownloadManager)
